class Calconstruction {
    constructor(calculatormain) {
        this.calculatormain = document.getElementById(calculatormain);
        this.currencyTitle = this.calculatormain?.getAttribute('data-currencytitle')
        this.profitRateYes = this.calculatormain?.getAttribute('data-profityes')
        this.profitRateNo = this.calculatormain?.getAttribute('data-profitno')
        this.init();
        
    }
    
    init() {
        if(this.calculatormain){
            this.setupJQueryPlugins();
            const propertyValue = this.calculatormain.querySelector('#property_value');
            propertyValue.addEventListener('input', () => this.numberOnly(propertyValue.id));
    
            const percentFinanceInput = this.calculatormain.querySelector('#percent_finance_input');
            percentFinanceInput.addEventListener('input', () => this.numberOnly(percentFinanceInput.id));
            
            const tenureInput = this.calculatormain.querySelector('#tenure_input');
            tenureInput.addEventListener('input', () => this.numberOnly(tenureInput.id));
            
            const btnCalculate = this.calculatormain.querySelector('#btnCalculate');
            btnCalculate.addEventListener('click', () => this.calculateInstallment());
            
            const btnReset = this.calculatormain.querySelector('#btnReset');
            btnReset.addEventListener('click', () => this.clearFields());
            
            const radiosalarytransferyes = this.calculatormain.querySelector('#radio-salary-transfer-yes')
            const radiosalarytransferno = this.calculatormain.querySelector('#radio-salary-transfer-no')
            radiosalarytransferyes.addEventListener('click',()=>this.calculateInstallment())
            radiosalarytransferno.addEventListener('click',()=>this.calculateInstallment())
        }
    }

    setupJQueryPlugins() {
        
        const pathname = window.location.href;
        let checkLang = document.querySelector("html").getAttribute('lang');
        let max = $(this.calculatormain).find("#percent_finance").attr('data-slider-max');
        let min =  $(this.calculatormain).find("#percent_finance").attr('data-slider-min');
        let step =  $(this.calculatormain).find("#percent_finance").attr('data-slider-step');
        let value =  $(this.calculatormain).find("#percent_finance_input").attr('data-slider-initialvalue');

            $(this.calculatormain).find("#percent_finance").slider({
                range: "min",
                value: parseInt(value)||0,
                min: parseInt(min)|| 0,
                max: parseInt(max)||100,
                step: parseInt(step)||1,
                isRTL: checkLang === 'ar' ? true : false,
                slide: (event, ui) => {
                    $('#percent_finance_input').val(ui.value);
                }
            });

            let maxtenure = $(this.calculatormain).find("#tenure").attr('data-slider-max');
            let mintenure =  $(this.calculatormain).find("#tenure").attr('data-slider-min');
            let stepTenure =  $(this.calculatormain).find("#tenure").attr('data-slider-step');
            let valueTenure =  $(this.calculatormain).find("#tenure_input").attr('data-slider-initialvalue');
            $(this.calculatormain).find("#tenure").slider({
                range: "min",
                value: parseInt(valueTenure)||0,
                min: parseInt(mintenure)|| 0,
                max: parseInt(maxtenure)||100,
                step: parseInt(stepTenure)||1,
                isRTL: checkLang === 'ar' ? true : false,
                slide: (event, ui) => {
                    $('#tenure_input').val(ui.value);
                }
            });

            $(this.calculatormain).find('[id$="radio-salary-transfer-yes"]').click(() => {
                $('[id$="profit_rate"]').text(this.profitRateYes + "%");
                this.calculateInstallment();
            });

            $(this.calculatormain).find('[id$="radio-salary-transfer-no"]').click(() => {
                $('[id$="profit_rate"]').text(this.profitRateNo + "%");
                this.calculateInstallment();
            });

            this.clearFields();
        
    }

    clearFields() {
        $(this.calculatormain).find('[id$="profit_rate"]').text(this.profitRateYes + "%");
        $(this.calculatormain).find('[id$="total_finance_amount"]').text(this.currencyTitle + "0");
        $(this.calculatormain).find('[id$="monthly_installment"]').text(this.currencyTitle + "0");

        $(this.calculatormain).find("#radio-salary-transfer-yes").prop("checked", true);
        $(this.calculatormain).find("#radio-salary-transfer-no").prop("checked", false);

        $(this.calculatormain).find('#property_value').val("0");
        $(this.calculatormain).find('#percent_finance_input').val("0");
        $(this.calculatormain).find('#tenure_input').val("0");

        $(this.calculatormain).find("#percent_finance").slider("value", 0);
        $(this.calculatormain).find("#tenure").slider("value", 0);
    }

    numberOnly(id) {
        const element = document.getElementById(id);
        element.value = element.value.replace(/[^0-9]/g, "");
    }

    calculateInstallment() {
        const propertyValue = parseFloat($("#property_value").val());
        const percentFinance = parseFloat($("#percent_finance_input").val());
        const tenure = parseFloat($("#tenure_input").val());
        let profitRate = parseFloat($('[id$="profit_rate"]').text().replace('%', ''));

        const totalFinanceAmt = (propertyValue * percentFinance / 100);
        if (!isNaN(totalFinanceAmt)) {
            $('[id$="total_finance_amount"]').text(this.currencyTitle + totalFinanceAmt);
        }

        if (tenure !== 0) {
            const monthlyInstallments = Math.round(totalFinanceAmt * (profitRate / 12) / 100 * (Math.pow(1 + (profitRate / 12) / 100, tenure * 12) / (Math.pow(1 + (profitRate / 12) / 100, tenure * 12) - 1)));
            if (!isNaN(monthlyInstallments)) {
                $('[id$="monthly_installment"]').text(this.currencyTitle + monthlyInstallments);
            }
        } else {
            $('[id$="monthly_installment"]').text(this.currencyTitle + "0");
        }
    }
}

export default Calconstruction;
